<div class="m-header">
	<a [style.pointer-events]="userService.isDemoMode() ? 'none' : 'auto'" (click)="returnToHome()" class="b-brand" style="cursor: pointer">
		<!-- ========   change your logo hear   ============ -->
		@if (themeMode === false) {
			<img src="assets/images/vms-logo.png" width="60" height="60" alt="logo-img" class="logo pointer" />
		} @else {
			<img src="assets/images/vms-logo.png" width="60" height="60" alt="logo-img" class="logo" />
		}
	</a>
	<!-- ======= Menu collapse Icon ===== -->
	<div class="pc-h-item" *ngIf="!hideNavToggle">
		<a
			href="javascript:"
			class="pc-head-link head-link-secondary m-0 mobile-menu"
			[ngClass]="{ on: navCollapsed }"
			id="sidebar-hide mobile-collapse"
			(click)="navCollapse()"
			title="Click to Menu Collapse"
		>
			<i class="fas fa-bars"></i>
		</a>
	</div>
</div>
